const TeaMass=[
    {
        id:1,
        title:"Зелений 0,450л",
        price:"75 грн",
        src: require('../img/tea.webp'),
        text:"",
    },
    {
        id:2,
        title:"Чорний 0,450л",
        price:"75 грн",
        src: require('../img/tea.webp'),
        text:"",
    },
    {
        id:3,
        title:"Нахабний фрукт 0,450л",
        price:"75 грн",
        src: require('../img/tea.webp'),
        text:"",
    },
    {
        id:4,
        title:"Альпійські лука 0,450л",
        price:"75 грн",
        src: require('../img/tea.webp'),
        text:"",
    },
    {
        id:5,
        title:"Молочний острів 0,450л",
        price:"75 грн",
        src: require('../img/tea.webp'),
        text:"",
    },
    {
        id:6,
        title:"1001 ніч 0,450л",
        price:"75 грн",
        src: require('../img/tea.webp'),
        text:"",
    },
    {
        id:7,
        title:"Каркаде 0,450л",
        price:"75 грн",
        src: require('../img/tea.webp'),
        text:"",
    },
    {
        id:8,
        title:"Королівський десерт 0,450л",
        price:"75 грн",
        src: require('../img/tea.webp'),
        text:"",
    },
    {
        id:9,
        title:"Ромашка 0,450л",
        price:"75 грн",
        src: require('../img/tea.webp'),
        text:"",
    },
    {
        id:10,
        title:"Сау-сеп 0,450л",
        price:"75 грн",
        src: require('../img/tea.webp'),
        text:"",
    },
    {
        id:11,
        title:"Бергамот 0,450л",
        price:"75 грн",
        src: require('../img/tea.webp'),
        text:"",
    },
    {
        id:12,
        title:"Ройбуш 0,450л",
        price:"75 грн",
        src: require('../img/tea.webp'),
        text:"",
    },
    
]

export default TeaMass;